<template>
  <div id="userOrder">
    <div class="tabsContainer">
      <el-tabs v-model="form.status" @tab-click="handleClick">
        <el-tab-pane :label="pendingTabText" name="待处理"></el-tab-pane>
        <el-tab-pane :label="beingProcessedTabText" name="处理中"></el-tab-pane>
        <el-tab-pane :label="historicalIssueTabText" name="历史问题"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="list" v-loading="loanding">
      <div class="searchBox">
        <div class="myInput">
          <i class="el-icon-search"></i>
          <input type="text" v-model="form.searchText" @keydown.enter="getData()" :placeholder="$fanyi('请输入订单号搜索')" />
        </div>
        <button class="searchBtn" @click="
          form.page = 1
        getData(form)
          ">
          {{ $fanyi('搜索') }}
        </button>
      </div>
      <!-- 表格 -->
      <div class="dataBody">
        <el-table :data="tableData" border style="width: 1020px" :header-cell-style="{
          'text-align': 'center',
          background: '#F5F5F5',
          color: 'black',
          'font-size': '14px',
          'border': 'none',
          'color': '#121212',
          'height': '50px',

          'padding': '0px 10px',
          'font-weight': '500',
        }" :cell-style="{ 'text-align': 'center', 'font-size': '14px', 'height': '50px', 'padding': '0 10px', }">
          <el-table-column type="index" width="70" label="No" align="center">
          </el-table-column>

          <el-table-column prop="date" :label="$fanyi('订单号')" width="200" align="center">
            <template slot-scope="scope">
              <button class="order_sn" @click="toDetailPage(scope.row)">
                {{ scope.row.order_sn }}
              </button>
            </template>
          </el-table-column>
          <el-table-column prop="name" :label="$fanyi('联系负责人')" @click="tocaht" align="center">
            <template slot-scope="scope">
              <div class="lianxirenBox">
                <img class=" lianxiren" src="../../../../assets/newassets/issueOrder/contact30px.svg" alt=""
                  @click="tocaht" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="problem_goods_created_at" :label="$fanyi('问题提出日期')" align="center">
          </el-table-column>
          <el-table-column prop="count" :label="$fanyi('有问题的商品数')" align="center">
          </el-table-column>
          <el-table-column prop="sum" :label="$fanyi('问题商品数量')" align="center">
          </el-table-column>
        </el-table>
        <div class="allpag">
          <span></span>
          <el-pagination @current-change="handleCurrentChange" :current-page="form.currentPage" :page-size="10"
            :page-sizes="[10, 20, 30, 50]" layout=" prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        status: '待处理',
        page: 1,
        pageSize: 10,
        searchText: '',
      },
      loanding: false,
      tableData: [],
      total: 0,
      pendingTabText: this.$fanyi('等待处理'),
      beingProcessedTabText: this.$fanyi('处理中'),
      historicalIssueTabText: this.$fanyi('所有问题产品详情'),
    }
  },
  components: {},
  computed: {},
  created() {
    this.getData()
    this.getTitleNumber()
  },
  methods: {
    //点击订单号新标签打开
    toDetailPage(row) {
      let baseUrl = window.location.origin
      window.open(baseUrl + `/faultyproductsOrderDetail?order_sn=${row.order_sn}&status=${this.$fun.toCode(this.form.status)}`, '_blank')
    },
    // 打开聊天窗口
    tocaht() {
      window.open('https://t.me/RakumartUA', '_blank')
    },
    handleClick(tab) {
      this.form.page = 1
      this.getData(this.form)
    },
    // 获取种类数量数据
    getTitleNumber() {
      this.$api.problemGoodsOrderNum().then((res) => {

        if (res.code != 0) return
        if (res.data.length == 0) return false
        res.data.forEach((item) => {
          switch (item.table) {
            case '待处理':
              this.pendingTabText = this.pendingTabText + ` (${item.num})`
              break
            case '处理中':
              this.beingProcessedTabText =
                this.beingProcessedTabText + ` (${item.num})`
              break
            case '已处理':
              this.historicalIssueTabText =
                this.historicalIssueTabText + ` (${item.num})`
              break
          }
        })
      })
    },
    // 获取数据
    getData() {
      this.loanding = true
      let datas = {
        status: this.form.status,
        pageSize: this.form.pageSize,
        page: this.form.page,
        keywords: this.form.searchText,
      }
      this.$api.problemGoodsOrderList(datas).then((res) => {
        this.loanding = false
        if (res.code != 0) return
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    handleSizeChange(val) {
      this.form.pageSize = val
      this.form.pageSize = 1
      this.getData(this.form)
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.getData(this.form)
    },
  },
}
</script>
<style lang="scss" scoped>
#userOrder {
  width: 1060px;
  background: #FFFFFF;
  border-radius: 20px;
  overflow: hidden;
  padding: 0 20px;

  button {
    cursor: pointer;
  }

  /deep/.el-table__empty-block {
    height: 80px !important;
    border-bottom: 0.5px solid #dfdfdf;
  }

  /deep/.el-range-separator {
    width: 3px;
    height: 20px;
    // background-color: pink;
    background: url('../../../../assets/date.png') no-repeat center;
  }

  /deep/ .el-date-editor {
    position: relative;

    .el-input__icon {
      display: none;
    }
  }

  /deep/.el-table {
    border-radius: 12px;

    overflow: hidden;
    border-bottom: none;
    border-color: #dfdfdf;

    .el-table__cell {
      border-color: #dfdfdf;

    }

    tr {
      border-color: #dfdfdf;

      &:last-child {


        overflow: hidden;

        td {

          &:first-child {
            border-radius: 0 0 0px 12px;
          }

          &:last-child {
            border-radius: 0 0 12px 0px;
          }

        }
      }
    }

    .el-table__empty-block {
      border-radius: 0 0 12px 12px;
    }
  }

  /deep/.el-table__header-wrapper {
    border-bottom: 1px solid #dfdfdf;


    .cell {
      line-height: 14px;
    }
  }

  .tabsContainer {
    border-radius: 0;
    border-bottom: 1px solid #DFDFDF !important;
    height: 58px;
    padding-top: 10px;


    /deep/ .el-tabs__active-bar {
      background-color: #D12A1D;
    }

    /deep/ .el-tabs__nav-wrap::after {
      display: none;
    }

    /deep/ .el-icon-arrow-left {
      font-size: 14px;
    }

    /deep/ .el-icon-arrow-right {
      font-size: 14px;
    }

    /deep/ .el-tabs__item {
      height: 48.5px !important;
      font-size: 14px;
      color: #121212;

      &:hover {
        color: #D12A1D;
      }
    }

    /deep/ .is-active {
      color: #D12A1D;

    }
  }

  .list {
    padding-top: 20px;
    min-height: 200px;



    .searchBox {
      display: flex;
      margin-bottom: 20px;


      .myInput {
        width: 400px;
        height: 40px;
        border-radius: 12px;
        position: relative;
        display: flex;
        align-items: center;
        // overflow: hidden;
        margin-right: 20px;

        >i {
          width: 20px;
          height: 24px;
          margin: 9px 11px 9px 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          color: #A2A2A2;
        }

        >input {
          border: 1px solid #e2e2e2;
          width: 100%;
          height: 100%;
          border-radius: 12px;
          font-size: 14px;
          padding-left: 40px;
          padding-right: 10px;
          transition: 0.3s;

          &:focus {
            border-color: #ff730b;
          }

          &::placeholder {
            color: #9a9a9a;
          }
        }
      }

      /deep/.el-date-editor {
        border-radius: 12px;
        width: 296px;
        height: 40px;
        margin-right: 20px;
        line-height: 32px !important;

        .el-input__inner {
          padding: 0px !important;
          border-radius: 12px;
        }

        .el-range-input {
          font-size: 14px;
          border-radius: 12px;
        }

        .el-range-separator {
          width: 50px;
          line-height: 23px;
        }

        .el-range__icon {
          line-height: 25px;
        }
      }


      .searchBtn {
        width: 80px;
        height: 40px;
        background: #D12A1D;
        border-radius: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
        font-size: 14px;


      }

      .cancelledBtn {
        width: 150px;
        height: 40px;
        border-radius: 12px;
        border: 1px solid #D12A1D;


        text-align: center;
        cursor: pointer;
        margin-left: 54px;
        font-weight: 400;
        font-size: 16px;
        color: #D12A1D;
        line-height: 40px;

      }
    }


    .dataBody {
      width: 100%;

      .order_sn {
        font-weight: 400;
        font-size: 14px;
        color: #D12A1D;
        line-height: 20px;
        background-color: transparent;

        &:hover {
          text-decoration: underline;
          font-weight: 400;
          font-size: 14px;
          color: #D12A1D;
        }
      }

      .lianxirenBox {
        display: flex;
        align-items: center;
        justify-content: center;

        .lianxiren {
          width: 30px;
          height: 23px;
          cursor: pointer;
        }
      }

    }

    .allpag {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 30px 0px;

      .el-pagination {
        display: flex;
        align-items: center;

      }

      >a {
        display: inline-block;
        border: 1px solid #dcdfe6;
        height: 28px;
        // background-color: white;
        text-align: center;
        padding: 0 10px;
        font-size: 13px;
        line-height: 28px;
        border-radius: 0;
      }

      /deep/.btn-prev {
        width: 30px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #DFDFDF;
        padding: 0;
        margin-right: 15px;
        margin-left: 20px;

        .el-icon {
          font-size: 16px;
          color: #000000;
        }
      }

      /deep/.btn-next {
        width: 30px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #DFDFDF;
        padding: 0;
        margin-left: 15px;



        .el-icon {
          font-size: 16px;
          color: #000000;
        }
      }

      /deep/ .el-pagination__jump {

        .el-input {
          width: 50px;
          height: 30px;
          background: #FFFFFF;
          border-radius: 8px;
          margin-left: 5px;

          font-weight: 400;
          font-size: 14px;
          color: #000000;

          .el-input__inner {
            height: 30px;
            border-radius: 8px;
          }

        }
      }

      /* 分页被选中的页码样式 */
      /deep/ .el-pager li {
        margin: 0 5px;
        width: 30px;
        line-height: 30px;
        height: 30px;
        border-radius: 8px;
        // box-shadow: 0 0 6px 0 rgba(61, 61, 61, 0.1);

        &:hover {
          color: #D12A1D;
        }

        &.active {
          width: 30px;

          height: 30px;
          background: #D12A1D;
          line-height: 30px;
          color: #fff;
          border-radius: 8px;
        }
      }
    }
  }

}
</style>
